import type { SitePage } from '@/config/pages'
import { SeoHead } from '@/components/seo/SeoHead'
import { pageSchema, pageTitle, teamJsonLd } from '@/lib/seo'

/** Head tags for a fixed page, straight from its entry in src/config/pages.ts. `jsonLd` adds
    structured data of the page's own, such as the FAQ's questions. */
export const PageSeo = ({ page, jsonLd = [] }: { page: SitePage; jsonLd?: Record<string, unknown>[] }) => {
  const title = pageTitle(page.title)

  return (
    <SeoHead
      title={title}
      description={page.description}
      canonicalPath={page.path}
      noindex={!page.index}
      fullSnippet={page.fullSnippet}
      jsonLd={
        page.schema
          ? pageSchema(
              {
                type: page.schema.type,
                path: page.path,
                name: page.schema.name ?? title,
                description: page.description,
              },
              [...(page.schema.team ? teamJsonLd() : []), ...jsonLd],
            )
          : undefined
      }
    />
  )
}
